import { render, staticRenderFns } from "./ResolveConversationModal.vue?vue&type=template&id=41a88fdc&scoped=true&"
import script from "./resolve-conversation-modal.ts?vue&type=script&lang=ts&"
export * from "./resolve-conversation-modal.ts?vue&type=script&lang=ts&"
import style0 from "./ResolveConversationModal.vue?vue&type=style&index=0&id=41a88fdc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a88fdc",
  null
  
)

export default component.exports